import action from '../helpers/rest-client'
import { paginationString } from '../helpers/getPaginationString'
import {
  NewNotificationOutDto,
  EditNotificationOutDto,
  DeleteNotificationOutDto,
  GetOneNotificationOutDto,
  GetAllNotificationsOutDto,
  NotificationInDto,
  GetNotificationsMetricsOutDto,
} from '../types/notification.dto'

const path = '/notification'

class Notification {
  public async new(payload: NewNotificationOutDto) {
    return action
      .Post({
        url: `${path}`,
        body: payload,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public async edit({ idNotification, ...rest }: EditNotificationOutDto) {
    return action
      .Patch({
        url: `${path}/${idNotification}`,
        body: rest.body,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public async getAll({ filters, pagination, sort }: GetAllNotificationsOutDto) {
    const filtersJSON = filters && Object.keys(filters).length > 0 ? `&filters=${JSON.stringify(filters)}` : ''

    return action
      .Get({
        url: `${path}/${paginationString({ pagination, sort })}${filtersJSON}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public async getOne({ idNotification }: GetOneNotificationOutDto) {
    return action
      .Get({
        url: `${path}/${idNotification}`,
      })
      .then(async (response: NotificationInDto) => {
        return { response };
      })
      .catch(error => {
        return { error };
      });
  }

  // public async getOne({ idNotification }: GetOneNotificationOutDto) {
  //   return action
  //     .Get({
  //       url: `${path}/${idNotification}`,
  //     })
  //     .then(async (response: NotificationInDto) => {
  //       if (response.signer.signature) {
  //         const { key, mimeType } = response.signer.signature as MediaDto
  //         const url = await services.media.download({ key, mimeType })
  //         return {
  //           response: {
  //             ...response, signature: {
  //               ...response.signer.signature, ...url
  //             }
  //           }
  //         }
  //       } else {
  //         return { response }
  //       }
  //     })
  //     .catch(error => {
  //       return { error }
  //     })
  // }

  public async deleteOne({ idNotification }: DeleteNotificationOutDto) {
    return action
      .Del({
        url: `${path}/${idNotification}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getMetrics({ filters }: GetNotificationsMetricsOutDto) {
    const filtersJSON = filters ? `?filters=${JSON.stringify(filters)}` : ''

    return action
      .Get({
        url: `${path}/metrics${filtersJSON}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }
}

const notification = new Notification()
export default notification
